<template>
  <div class="container-fluid ">
    <div class="chart-container centering ">
      <span style=" border-bottom: solid 3px #F9CDAD;">{{'「'+chartdata.xylabel[0] + '」と「' + chartdata.xylabel[1] + '」'}}</span>
      <histgram :chartData="Dataset" :options="options" :height="450"></histgram>
    </div>
    <div class="righter">
      <button type="button" class="btn btn-danger" @click="exchange()">x-y交換</button>
    </div>
    <div class="row">
      
      <br>
      <div class="col-lg-6" v-for="(xy, i) in xys" :key="'xy' + i">
        <div class="card" >
          <div class="card-header">
            <div class="subject ">
              {{xy}}軸
            </div>

          </div>
          <div class="card-body">
            <div class="form-row">
              <div v-for="(pb, j) in xytype" :key="'pb' + j" class="col-md-4">
                <B class="underline" for="team">{{pb}}</B>

                <v-select label="team" class="inputbox" :clearable="false"
                v-model="xy_select[i][j]"
                :options="select_options(i, j)"
                ></v-select>
              </div>
              <div v-if="i==1" class="col-lg-4">
                <B class="underline">x軸から</B>
                <v-select label="team" class="inputbox" :clearable="false"
                v-model="y_yearz" :options="['3年後', '2年後', '1年後', '同年', '1年前', '2年前', '3年前']"
                ></v-select>
              </div>
            </div>
            <a class="link" @click="OpenSetting(i);" style="color: #912d48;text-decoration : underline;font-size:95%;"><img src="../assets/setting.svg" width="16" height="16">詳細</a>
            <div v-if="i==0&&setting_openo==true||i==1&&setting_opent==true">
              <div class="form-group form-inline">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" :id="'ro-'+i"
                  v-model="gmwari[i]"
                  >
                  <label class="custom-control-label" :for="'ro-'+i">試合ごと</label>
                </div>
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" :id="'os-'+i"
                  v-model="outstanding[i]"
                  >
                  <label class="custom-control-label" :for="'os-'+i">傑出度</label>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <br>
      <div class="col-lg-12">
        <div class="card" >
          <div class="card-header">
            対象範囲
          </div>
          <div class="card-body">
          <B class="underline">年度範囲</B>
            <div class="form-row">
              <div v-for="(rse, r) in [0, 1]" :key="'rse' + r" class="col-lg-6">
                {{r==0?'最小':'最大'}}
                <v-select label="team" class="inputbox" :clearable="false"
                v-model="yearrange[r]"
                :options="year_selectop" taggable
                ></v-select>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>

import tpitcher from '../assets/ypitcherTeamRecord_s.json'

import tbatter from '../assets/ybatterTeamRecord_s.json'

import histgram from './histgram.vue'
import correl from './correl.js'

var sta = require('simple-statistics');
import Mixin from '../mixins/utility'
export default {
  name: 'about',
  mixins: [Mixin],
  components: {
      histgram
  },
  data() {//xy_select
    return {
      xys: ["x", "y"],
      xytype: ["投打", "成績"],
      pb_selectop: ['チーム','打撃','打撃(SABR)','投球','投球(SABR)'],
      xy_select: [["打撃","得点"],["打撃","得点"]],//投/基本
      yearrange: [1950, 2019],
      year_selectop: [],
      gmwari: [true, true],
      outstanding : [false, false],
      setting_openo: false,
      setting_opent: false,
      options: {},
      chartdata: {xylabel: ['','']},
      y_yearz: "同年",
      teamdatas : {},
      //DH？PF？
    }
  },
  created: function () {
    this.PageLoads()
  },
  mounted: function () {
    document.title = "相関図ジェネレーター"
  },
  computed: {
    Dataset() {
      const select = this.xy_select, range = this.yearrange
      let data = {
        xylabel: [],
        datasets: [
          {
            label:'球団',
            type: 'scatter',
            labels: [],
            backgroundColor: [],
            borderColor: [],
            data: [],
            borderWidth: 1,
            yAxisID: "y-axis-1",
          },
        ]
      }
      function getTarget(teams, range) {
        let list = []
        Object.keys(teams).some(nen => {
          const nennum = Number(nen.replace(/[^0-9]/g, ''));
          if(range == null || (range[0] == null || nennum >= range[0]) && (range[1] == null || nennum <= range[1])){
            Object.keys(teams[nen]).some(t => {
              if(teams[nen][t]["LTtype"] == 1) list.push(teams[nen][t])
            })
          }
        })
        return list
      }
      const target = getTarget(this.teamdatas, this.yearrange)

      //data.datasets[0].data.label = ""

      let correlist = [[], []], correl_data = []
      target.some((t, tindex) => {
        let point = [], tname = null
        this.xys.some((xy, i) => {
          let team = t;
          if(i == 0){
            tname = team.name
          }else{
            const yy = this.YearConv(this.y_yearz)
            if(yy != 0){
              const x_name = this.teamID(team.name)
              const nen = Number(team["nen"].replace(/[^0-9]/g, ''))
              team = target.find(tt => {
                const t_n = Number(tt["nen"].replace(/[^0-9]/g, ''))
                return (t_n == nen + yy && this.teamID(tt.name) == x_name && t_n >= 1939 && nen >= 1939)
              })
            }
          }
          if(team){
            const leagname = this.Leag(team.name, team.nen)//leaglist
            const lrecord = this.teamdatas[team["p"]["nen"]][leagname]
            const pb = select[i][0] == "チーム" ? "t" : (select[i][0].indexOf("投") > -1) ? "p": "b"; 
            const rname = this.RecordName(pb, select[i][1], 1)
            let warif;
            if(this.gmwari[i] && ((pb == "t" && rname == "G") == false && (pb == "p" && rname == "GS") == false && rname != 'PWR' && rname != 'year')){
              warif = team["t"]["G"]
            }else{
              warif = 1
            }
            let record = this.calcRecord(rname, team[pb], warif, lrecord[pb])
            if(record != undefined||record==0){
              if(this.outstanding[i] && rname!= "year")record = this.calcWari(100*record, this.calcRecord(rname, lrecord[pb], warif * lrecord.teamsum, lrecord[pb])).toFixed(1)
              point.push(Number(record))
            }else{
              return true
            }
          }
        })
        if(point.length == 2){
          correlist[0].push(point[0])
          correlist[1].push(point[1])
          data.datasets[0].data.push({x: point[0], y: point[1]})
          correl_data.push({x: point[0], y: point[1]})
          data.datasets[0].labels.push(tname)

          const color = this.team_Color(tname)
          data.datasets[0].backgroundColor.push(color[0])
          data.datasets[0].borderColor.push(color[1])
        }
      })
      //data.xylabel.push(this.xy_select[1][0] + this.xy_select[1][1])
      if(correl_data.length != 0){
      console.log(correl_data)
        select.some((sel, i) => {
          let str = (sel[0] == "チーム" ? "チーム" : (sel[0].indexOf("投") > -1) ? "投球": "打撃") + '・' + sel[1]
          if(i == 1)str += (this.y_yearz == "同年" ? "": "(" + this.y_yearz + ")")
          data.xylabel.push(str)
        })
        const kaiki = correl(correl_data)
        data.datasets.push(kaiki.data)
      }else{
        data.xylabel = ["", ""]
      }
      const corr = (correlist[0].length>0 ? (sta.sampleCorrelation(correlist[0], correlist[1]).toFixed(3)) : 0)
      this.options = this.Optionsset(data, '相関係数r=' + corr + ' (n=' + correlist[0].length + ')')
      this.chartdata = data
      return data
      //
    },
  },
  methods: {
    OpenSetting(xy) {
      if(xy==0)this.setting_openo=!this.setting_openo
      if(xy==1)this.setting_opent=!this.setting_opent
    },
    YearConv(str) {
      switch(str){
        case "3年前":
          return -3
        case "2年前":
          return -2
        case "1年前":
          return -1
        case "同年":
          return 0
        case "1年後":
          return 1
        case "2年後":
          return 2
        case "3年後":
          return 3
      }
      return 3
    },
    exchange () {
      function ex(array) {
        const last = array.pop()
        array.unshift(last)
      }
      ex(this.xy_select)
      ex(this.gmwari)
      if(this.y_yearz != "同年"){
        if(this.y_yearz.indexOf("年前") > -1){
          this.y_yearz = this.y_yearz.replace("年前", "年後")
        }else{
          this.y_yearz = this.y_yearz.replace("年後", "年前")
        }
      }
    },
    select_options (xy, type){
      if(type== 0)return this.pb_selectop
      return this.select_stats(this.xy_select[xy][0])
    },
    select_stats (pb) {
      const list = {
        t:['year', 'G', 'W', 'L', 'D', 'WR', 'PWR'],
        pbas:['G', 'W', 'L', 'SV', 'HLD', 'CG', 'ShO', 'FG', 'WR', 'TBF', 'IP', 'H', 'HR', 'BB', 'HBP', 'SO', 'WP', 'BK', 'R', 'ER', 'ERA'],
        bbas:['G', 'PA', 'AB', 'R', 'H', 'SING', 'SEC', 'THI', 'HR', 'TB', 'RBI', 'SB', 'CS', 'SH', 'SF', 'BB', 'IBB', 'HBP', 'SO', 'GDP', 'AVG', 'OBP','SLG'],
        padv:['FIP', 'SOp', 'BBp', 'HRp', 'BABIP', 'WHIP', 'AVG', 'Kn', 'BBn', 'HRn', 'LOB', 'KBB'],
        badv:['OPS', 'SOp', 'BBp', 'HRp', 'BABIP', 'IsoP', 'BBK', 'Speed', 'RC'],
      }
      let key = "t", pbf = "t"
      if(pb != 'チーム'){
        if(pb.indexOf("投") > -1){key = "p";pbf = "p";}else{key = "b";pbf = "b";}
        if(pb.indexOf("SABR") == -1)key += "bas";else key += "adv"
      }
      let namelist = []
      list[key].some(r => {
        namelist.push(this.RecordName(pbf, r, 0))
      })
      return namelist
    },
    async PageLoads () {
      await this.onLoad()
    },
    async onLoad () {
      {
        const xy = 0
        const list = this.select_stats(this.xy_select[xy][0])
        while(this.xy_select[xy][1] == "得点"){
          const r = list[parseInt(Math.random() * (list.length - 1))]
          this.xy_select[xy][1] = this.RecordName('b', r, 0)
        }
      }
      const timports = [{p:tpitcher, b:tbatter}]
      let leaglist = {}
      timports.some((tls) =>{
        Object.keys(tls).some(pb =>{
          let bpdatas;
          bpdatas = [tls[pb]]
          bpdatas.some(teams => {
            Object.keys(teams).some(team => {
              let data = teams[team]
              if(data){
                const teamname = team
                if(!this.teamdatas[data.nen])this.teamdatas[data.nen]={}
                if(!this.teamdatas[data.nen][teamname])this.teamdatas[data.nen][teamname]={p:{}, b:{}, LTtype: 1, name:team}
                this.teamdatas[data.nen][teamname][pb] = data

                const leagname = this.Leag(team, data.nen)//leaglist
                if(!this.teamdatas[data.nen])this.teamdatas[data.nen]={}
                if(!this.teamdatas[data.nen][leagname]){
                  this.teamdatas[data.nen][leagname]={p:{}, b:{}, LTtype: 0, name: leagname, teamsum: 0}
                }
                if(pb == "p")this.teamdatas[data.nen][leagname]["teamsum"]++
                Object.keys(data).some(r => {
                  if(r != "name" && r != "nen" && r!= "AA"){
                    if(!this.teamdatas[data.nen][leagname][pb][r])this.teamdatas[data.nen][leagname][pb][r] = 0
                    this.teamdatas[data.nen][leagname][pb][r] += data[r]
                  }
                })
                this.teamdatas[data.nen][leagname][pb]["nen"] = data.nen
              }
            })
          })
        })
      })
      let nenlist = {}
      console.log(this.teamdatas)
      Object.values(this.teamdatas).some(teamy => {
        Object.values(teamy).some(team => {
          team["b"]["SING"] = team["b"]["H"] - team["b"]["SEC"] - team["b"]["THI"] - team["b"]["HR"]
          team["b"]["GS"] = team["p"]["GS"]
          team["b"]["TB"] = team["b"].H + team["b"].SEC + team["b"].THI * 2 + team["b"].HR * 3
          team["t"] = {}
          team["t"]["G"] = team["p"]["GS"]
          team["t"]["W"] = team["p"]["W"]
          team["t"]["L"] = team["p"]["L"]
          team["t"]["D"] = team["p"]["GS"] - team["t"]["W"] - team["t"]["L"]
          team["t"]["nen"] = team["p"]["nen"]
          team["nen"] = team["p"]["nen"]
          
          const PX=Math.pow(((team["b"]["R"] + team["p"]["R"])/team["p"]["GS"]),0.287),
          PythagenPat=Math.pow(team["b"]["R"],PX)/(Math.pow(team["b"]["R"],PX)+Math.pow(team["p"]["R"],PX));

          team["t"]["PWR"] = PythagenPat.toFixed(4)
          team["t"]["PW"] = Math.round(PythagenPat * team["t"]["G"])
          team["t"]["PL"] = team["t"]["G"] - team["t"]["PW"]

          if(team["t"]["nen"]){
            const nen_num = Number(team["t"]["nen"].replace(/[^0-9]/g, ''))
            nenlist[nen_num] = true
          }
          //console.log(team)
          //team[pb] = data//ここから
        })
      })
      console.log(this.teamdatas)
      this.year_selectop = Object.keys(nenlist)
    },//
    Optionsset (data, title) {
      let options = {
        maintainAspectRatio: true,
        tooltips: {
          callbacks: {
            title: function (tooltipItem, data){
              return;
            },
            label: function(tooltipItem, data) {
              var label = data.datasets[0].labels[tooltipItem.index];
              return label;
            },
            afterLabel: function (tooltipItem, data){
              return ['x: ' + data.xylabel[0] + ' ' + tooltipItem.xLabel, 'y: ' + data.xylabel[1] + ' ' + tooltipItem.yLabel]
              // + ': (' + tooltipItem.xLabel + ', ' + tooltipItem.yLabel + ')'
              //return "(" + data.xylabel[0] + tooltipItem[0].xLabel +  ", " + data.xylabel[1] + tooltipItem[0].yLabel + "" + ")";
            },
          }
        },
        title: {
          display: true,
          text: title
        },
        position: 'relative',
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
          position: 'top',
        },
        scales: {
          xAxes: [{
            type: 'linear',
            position: 'bottom',
            scaleLabel: {             
              display: true,          
              labelString: "",
            },
          }],
          yAxes: [{   
            scaleLabel: {
              display: true,          
              labelString: '' 
            },
            id: "y-axis-1",   // Y軸のID
            type: "linear",   // linear固定 
            position: "left", // どちら側に表示される軸か？
          }],
        }
      }
      options.scales.xAxes[0].scaleLabel.labelString = data.xylabel[0]
      options.scales.yAxes[0].scaleLabel.labelString = data.xylabel[1]
      //options.scales.yAxes[0].scaleLabel.labelString = this.xy_select[1][0] + this.xy_select[1][1]
      return options;
    }
  },
  
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.underline{
  background: linear-gradient(transparent 70%, #F9CDAD 70%);
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.container-fluid {
  margin: 10px;
}
.centering {
  text-align: center
}
.card-header {
  background-color: #FC9D9A;
  color: white;
}
.card-body {
  background-color: white;
  padding:1%;
}
</style>
<style>
.subject {
   text-align: left;  /* 文章を左寄せする(※) */
   float: left;     /* 左端に寄せて、後続を右側へ回り込ませる */
}
.righter {
   text-align: right; /* 文章を右寄せする */
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::before {
background-color: #db3543;
}
a {
  cursor: pointer;
  margin:0;
  padding:0;
  font-size:100%;
  vertical-align:baseline;
  background:transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue